import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ToggleButtonListItem from '../../../../../list-items/ToggleButtonListItem';
import { VISUALIZER_SHAPE } from '../../../Preview/PreviewDisplayConstants';

const visualizerShapes = [
    {value: VISUALIZER_SHAPE.CIRCLE, text: 'Circle'},
    {value: VISUALIZER_SHAPE.FLAT, text: 'Flat'},
];

const VisualizerShapeListItem = (props) => {
    const { visualizerShape, updateVisualizerShape } = props;
    const onShapeChange = (value) =>  updateVisualizerShape(value);

    return (
        <ToggleButtonListItem
            text='Shape'
            value={visualizerShape}
            onChange={onShapeChange}
            options={visualizerShapes}
        />
    );
};

const mapStateToProps = (state) => {
    const { shape: visualizerShape } = state.createPreview.present.videoSettings.visualizer;
    return { visualizerShape };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerShape = (shape) => dispatch(createActions.updateVisualizerShape(shape));
    return { updateVisualizerShape }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerShapeListItem);